import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { MediaOutletManager } from '@/components/admin/media-outlets/MediaOutletManager';
import { CustomOutletReviewQueue } from '@/components/admin/media-outlets/CustomOutletReviewQueue';
import Header from '@/components/Header';

export default function AdminMediaOutlets() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('outlets');

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto px-4 py-8 pt-24">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/admin/dashboard')}
              className="gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Back
            </Button>
            <div>
              <h1 className="text-3xl font-bold">Media Outlets Management</h1>
              <p className="text-muted-foreground mt-1">
                Manage media outlets and review custom submissions
              </p>
            </div>
          </div>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList>
            <TabsTrigger value="outlets">Media Outlets</TabsTrigger>
            <TabsTrigger value="review-queue">Review Queue</TabsTrigger>
          </TabsList>

          <TabsContent value="outlets" className="space-y-4">
            <MediaOutletManager />
          </TabsContent>

          <TabsContent value="review-queue" className="space-y-4">
            <CustomOutletReviewQueue />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
